var map = {
	"./images/desktop2/1992_gettyimages-1791521.jpg": 21,
	"./images/desktop2/2008_AP080907030763.jpg": 22,
	"./images/desktop2/2016_wimbledon_gettyimages-543402266.jpg": 23,
	"./images/desktop2/2018_AP22167566146868.jpg": 24,
	"./images/desktop2/81T08ptWSTL.jpg": 25,
	"./images/desktop2/AP22221520955145.jpg": 26,
	"./images/desktop2/GettyImages-1239808798.jpeg": 27,
	"./images/desktop2/gettyimages-1340130344.jpeg": 28,
	"./images/desktop2/gettyimages-159113029.jpg": 29,
	"./images/desktop2/gettyimages-466439876.jpg": 30,
	"./images/dropdown.svg": 31,
	"./images/hero-img-2-lg.jpg": 32,
	"./images/hero-img-2-sm.jpg": 33,
	"./images/logo_cnn.svg": 34
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;


//////////////////
// WEBPACK FOOTER
// ./src/media ^\.\/.*\.*
// module id = 39
// module chunks = 0